import { render } from "./Attached.vue?vue&type=template&id=2ef5b46a"
import script from "./Attached.vue?vue&type=script&lang=js"
export * from "./Attached.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__